import {
  EMAIL,
  PERSIST,
  REMEMBER_ME,
  TOKEN,
} from '../../../constants/ConfigConst';
import * as ROUTES from '../../../router/Routes';
import { LOGOUT } from '../../../store/Types';
import { oneDocentesAction } from '../../control_estudios/docentes/DocentesAction';
import { allEntVistasAction } from '../../entidad/ent_vistas/EntVistasAction';
import { allPermisosAction } from '../../permisos/PermisosAction';
import { allUsuVistasAction } from '../../usuario/usu_vistas/UsuVistasAction';
import { getEntidadesUsuariosAction } from '../../usuario/usuarios/UsuariosAction';
import {
  ADMIN_CONST,
  ENTITY_CONST,
  ROOT_CONST,
  TEACHER_CONST,
  USER_LOGIN,
  VISTAS_LOGIN,
} from './LoginReducer';
import { loginService } from './LoginService';

export const loginAction = async ({ dispatch, history, dataLogin }) => {
  try {
    const { user, password, isRemember } = dataLogin;
    const res = await loginService({ user, password });

    if (res.status >= 400 || !res.status)
      return res.message ?? 'Hubo un error en el inicio de sesión';

    if (res.status >= 200 && res.status < 203) {
      localStorage.setItem(EMAIL, user);
      localStorage.setItem(REMEMBER_ME, isRemember ? 1 : 0);
      localStorage.setItem(TOKEN, res.data.accessToken);

      if (
        res.data.user.rol !== ROOT_CONST &&
        res.data.user.entidades.length === 0
      ) {
        alert('No tiene entidades asignadas');
        return;
      }

      dispatch({ type: USER_LOGIN, payload: res.data });

      if (res.data.user.rol !== ROOT_CONST) {
        if (res.data.user.entidades.length > 1) {
          history.push(ROUTES.misEntidades.to);
          return;
        }

        const usuarioEntidad = await getEntidadesUsuariosAction(
          dispatch,
          res.data.user,
        );

        await getVistasLoginAction(dispatch, {
          rol: res.data.user.rol,
          idEntidad: usuarioEntidad.entidad.id,
          idUsuEntidad: usuarioEntidad.id,
          idUsuario: res.data.user.id,
        });

        if (res.data.user.rol === TEACHER_CONST && !res.data.user.admin) {
          await oneDocentesAction(dispatch, usuarioEntidad.id);
        }
      }

      history.push(ROUTES.dashboard.to);
    }
  } catch (e) {
    return false;
  }
};

export const logoutAction = async ({ dispatch, history }) => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(PERSIST);
  history.push(ROUTES.login.to);
  dispatch({
    type: LOGOUT,
  });
};

export const getVistasLoginAction = async (
  dispatch,
  { rol, idEntidad, idUsuEntidad, idUsuario },
) => {
  try {
    const vistas = [];
    const addVistas = (res) => {
      const newVistas = res
        .filter(
          (el) =>
            el.estatus.id === 1 &&
            !vistas.some(
              (vista) => vista.id === (el.vista.vista?.id ?? el.vista.id),
            ),
        )
        .map((el) => el.vista.vista ?? el.vista);
      vistas.push(...newVistas);
    };

    if (rol === ADMIN_CONST) {
      const resEntVistas = await allEntVistasAction(
        { dispatch, isLogin: true },
        { idEntidad },
      );
      addVistas(resEntVistas);
      dispatch({ type: VISTAS_LOGIN, payload: vistas });
    }

    if (rol === ENTITY_CONST || rol === TEACHER_CONST) {
      const resPermisos = await allPermisosAction(
        { dispatch, isLogin: true },
        { idUsuEntidad },
      );
      addVistas(resPermisos);
      dispatch({ type: VISTAS_LOGIN, payload: vistas });
    }

    if (![ADMIN_CONST, ENTITY_CONST].includes(rol)) {
      const resUsuVistas = await allUsuVistasAction(
        { dispatch, isLogin: true },
        { idUsuario },
      );
      addVistas(resUsuVistas);
    }

    dispatch({ type: VISTAS_LOGIN, payload: vistas });
  } catch (e) {
    return false;
  }
};
